import React, { useContext, useMemo } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import UserContext from '../contexts/UserContext';

type Props = {}

const TitleRestaurantSelector = (props: Props) => {
    const { selectedRestaurant, restaurantSettings, setSelectedRestaurantShortName } = useContext(UserContext);
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = React.useState("");
    const anchorRef = React.useRef<HTMLDivElement>(null);
    const displayedRestaurants = useMemo(() => {
        return restaurantSettings.filter(restaurant => restaurant.restaurantShortName !== selectedRestaurant?.restaurantShortName);
    }, [restaurantSettings, selectedRestaurant]);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event | React.SyntheticEvent) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }
        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    function handleOptionChange(shortName: string) {
        setSelectedRestaurantShortName(shortName);
        setOpen(false);
    }

    return (
        <>
            <div className={`font-bold flex gap-[1px] w-full ${displayedRestaurants.length > 0 ? 'cursor-pointer' : ''}`} ref={anchorRef} onClick={handleToggle}>
                <div className="text-white text-[22px] text-wrap pt-1">
                    {selectedRestaurant ? selectedRestaurant.name : ""}
                </div>
                {displayedRestaurants.length > 0 && (
                    <div className="text-utility-mutedIcon text-[20px] pt-1">
                        <ExpandMoreIcon style={{ fontSize: "28px", color: "white" }} />
                    </div>
                )}
            </div>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="top-start"
                transition
                disablePortal
                style={{ zIndex: 1000, textAlign: "center", }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                            marginLeft: "10px",
                            marginRight: "10px",
                        }}
                    >
                        <Paper
                            style={{ maxHeight: "360px", overflowY: "auto", }}
                        >
                            <ClickAwayListener onClickAway={handleClose}>
                                <div
                                    className=""
                                >
                                    <MenuList
                                        autoFocusItem={false}
                                        onKeyDown={handleListKeyDown}
                                    >
                                        {displayedRestaurants.map(option => {
                                            return <MenuItem
                                                key={option.restaurantShortName}
                                                onClick={() => handleOptionChange(option.restaurantShortName)}

                                            >
                                                {option.name}
                                            </MenuItem>
                                        })}
                                    </MenuList>
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default TitleRestaurantSelector